import * as React from 'react'
import ImageWithCaption from './ImageWithCaption'
import clsx from 'clsx'

const InlineImage = ({ image, position, config }) => (
  <ImageWithCaption
    {...image}
    className={clsx('w-[40%]', position === 'left' ? 'float-left mr-5' : 'float-right ml-5')}
    config={config}
  />
)

export default InlineImage
